import { useRef } from 'react';
import React from 'react'
import { useState } from 'react'
import DownloadDivWork from '../../Download/DownloadDiv';

const random = (min, max) => {
    return (Math.floor(Math.random()
        * (max - min + 1)) + min);
}
const GenMul = () => {

    const getswitch = (digit1) => {

        switch (digit1) {
            case '1':
                return random(2, 9)
                break;
            case '2':
                return random(10, 99)
                break;
            case '3':
                return random(100, 999)
                break;
            case '4':
                return random(1000, 9999)
                break;
            default:
                break;
        }
    }
    const [digit1, setdigit1] = React.useState();
    const [digit2, setdigit2] = React.useState();
    const [ques, setques] = React.useState();
    const [file, setfile] = React.useState();
    const [ansDownload, setansDownload] = React.useState(1);
    const [Particular, setParticular] = React.useState(0);
    const [ParticularNumber, setParticularNumber] = React.useState(0);
    const [down, setdown] = React.useState(0);
    const [btn, setbtn] = React.useState(0);
    const [ch, setch] = React.useState("m");
    // const mat = []
    const [mat, setmat] = useState([])
    const [refrsh, setrefrsh] = useState(0)
    let lowval = 1;

    const refpdf = useRef();

    const getmat = (ques, digit1, digit2) => {
        let temp = []
        let ele1;
        let ele2;
        for (let j = 0; j < ques; j++) {
            if (ParticularNumber) {
                ele1 = ParticularNumber;
            } else {
                ele1 = getswitch(digit1)
            }
            temp.push(ele1)

            ele2 = getswitch(digit2)
            temp.push(ele2)
            mat.push(temp)
            temp = []
        }
    }      
    function Xbtn(event) {
        setbtn(0)
        // window.location.reload()    
    }


    function cal(event) {
        event.preventDefault();
        if (refrsh) {
            window.location.reload()
        }
        getmat(ques, digit1, digit2)
        console.log(mat)
        let min;
        let max;

        switch (digit1) {
            case '1':
                min = 1
                max = 9
                break;
            case '2':
                min = 10
                max = 99
                break;
            case '3':
                min = 100
                max = 999
                break;
            case '4':
                min = 1000
                max = 9999
                break;
            default:
                break;
        }



        if (mat.length != 0) {
            let row = 2;
            setbtn(1)
        }

    }

    let props = {
        // ques:ques,
        mat: mat,
        file: file,
        ch: ch,
        ansDownload: ansDownload


    }

    const targetRef = useRef();

    return (
        <div className='bg'>
            <div className='main'>
                <form onSubmit={cal} className='main-form'>
          <h2 className='form-name'><span className='underline'>Multiplication</span> (Genrate)</h2>

                    {/* <h2 className='form-name'></h2> */}
                    <label htmlFor="digit">Number of Digit X Digit</label>
                    <div className='mul_dig'>
                        <input type="number" max="4" name="name" className='box input-fld' id="digit" placeholder="2" onChange={(e) => { setdigit1(e.target.value) }} required />
                        <h3>X</h3>
                        <input type="number" name="email" id="row" placeholder="3" className='box input-fld' required onChange={(e) => { setdigit2(e.target.value) }} />
                    </div>
                    {/* <div className='check'>
            <label htmlFor="zig">Select A Particular Number  -- </label>
            <input type="checkbox" name="zig-zag" id="zig-zag" onClick={() => { return Particular ? setParticular(false) : setParticular(true) }} />
            {Particular ? <input type="number" name="particular" className='input-fld' id="particular" onChange={(e) => { setParticularNumber(e.target.value) }} /> : ""}
          </div> */}
                    <label htmlFor='ques'>No Of Questions</label>
                    <input type="number" name="ques" id="ques" className='box' placeholder="10" max={100} required onChange={(e) => { setques(e.target.value) }} />
                    <label htmlFor='ques'>File name</label>
                    <input type="text" name="file" id="file" className='box' placeholder="file name.." required onChange={(e) => { setfile(e.target.value) }} />

                    <div className='submit'>
                        <input type="submit" id='reset' className='bt-purple' value="Finish" />
                        <input type="reset" id='reset' className='bt-purple' value="Refresh" onClick={() => { window.location.reload() }} />
                    </div>
                </form>
            </div>
            <div className={btn ? "popUp-download" : "hide-popUp-download"}>
                <button className='X-btn' onClick={() => { Xbtn() }}>X</button>
                <div className='download-ques-btn'>
                    <DownloadDivWork  {...{ mat, ques, file, ch }} />
                    <DownloadDivWork  {...{ mat, ques, file, ch, ansDownload }} />                </div>
            </div>
        </div>
    )
}
export default GenMul